import { Typography } from '@material-tailwind/react'
import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import Container from '../components/Container'
import illustration from '../assets/png/expired_invite.png'
import { usePageTitle } from '../hooks/toolkit'

const ExpiredLink = () => {
  const { t } = useTranslation()
  usePageTitle(t('expiredLink.pageTitle'))
  const [searchParams] = useSearchParams()
  const redeemCode = searchParams.get('redeemCode')
  return (
    <Container direction="col" className="text-primary text-center">
      <Typography variant="h2">{t('expiredLink.title')}</Typography>

      <Typography>{t('expiredLink.message')}</Typography>

      <div className="w-full md:w-1/2 h-[1px] border my-4" />

      <Typography variant="h4">
        <Trans
          i18nKey="expiredLink.dontWorry"
          components={{
            em: <em />,
            strong: <strong />,
          }}
        />
      </Typography>

      <Typography>
        {t('expiredLink.createAccount')}{' '}
        <strong className="underline">
          <Link to="/register">{t('expiredLink.here')}</Link>
        </strong>
        .
      </Typography>

      {redeemCode && (
        <Typography className="mt-2">
          {' '}
          {t('expiredLink.useCodeMessage')} <span className="font-black">{redeemCode}</span>
        </Typography>
      )}
      <img
        title={t('expiredLink.imageTitle')}
        alt={t('expiredLink.imageAlt')}
        src={illustration}
        className="opacity-90 mt-16 mb-8 mx-auto md:w-1/4"
      />

      <Typography className="mb-8">
        {t('expiredLink.needSupport')}{' '}
        <strong className="underline">
          <Link to="mailto:agami@mezzoforte.design">{t('expiredLink.contactUs')}</Link>
        </strong>
      </Typography>
    </Container>
  )
}

export default ExpiredLink
